import { createContext, useContext } from 'react'
import HttpService from '../api'

export const http = new HttpService()
export const httpPublic = new HttpService('', import.meta.env.VITE_API_PUBLIC_URL || import.meta.env.VITE_API_URL)
export const httpContext = createContext(http)
export const useHttp = () => useContext(httpContext)